module.exports = __webpack_public_path__ + "static/media/niranjana.d57e71f0.jpg";